import { useContext } from "react";
import { GlobalInfo } from "../App";
import Request from "./Request";
export default function Pending(props) {
  const { val, acc } = useContext(GlobalInfo);
  // const [pends, setpending] = useState([]);
  // const [pendno,setpen] =useState(0);

  return (
    <>
      <center>
        <div>
          <h2>CrowdGo-A helping hand</h2>
          {/* {console.log(props.arr)} */}

          <div className="row">
            {props.arr.map((element) => {
              return (
                <>
                  {element.approved ? (
                    <></>
                  ) : (
                    <div className="col-md-4" key={element.description}>
                      <Request cat={element} />{" "}
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </center>
    </>
  );
}
